import { AppColors } from "@/styles/colors";
import { formatCurrency } from "@/utils/format-currency";
import { Flex, Text } from "@chakra-ui/react";

import "@/components/common/section-components/card/text-elements.css";

interface Props {
  amount?: number;
}

export const BackupCheckTransferredAmountCard = ({ amount }: Props) => {
  return (
    <Flex
      minH={"82px"}
      gap="10px"
      padding="12px"
      flexDir="column"
      borderRadius="12px"
      border={`1px solid ${AppColors.WHITE_BORDER_1}`}
    >
      <Text
        fontWeight={700}
        textTransform="uppercase"
        fontSize="12px"
        color={AppColors.GRAY_TEXT}
      >
        Monto transferido
      </Text>
      <Flex alignItems="center" gap="10px">
        <Text className="requested-amount">${formatCurrency(amount)}</Text>
      </Flex>
    </Flex>
  );
};
